export const mobileWebviewActiveCookie = "showpass-mobile-webview-active";
